import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {useDidMountEffect} from 'shells/utils/hooks/use-did-mount-effect';

type Props = {
    onSave: (arg1: any) => void;
    setSavingToastKey: (arg1: string) => void;
    allowAdditionalAttendees: boolean;
};

export function AdditionalAttendees(props: Props) {
    const {onSave, setSavingToastKey} = props;
    const [allowAdditionalAttendees, setAllowAdditionalAttendees] = React.useState<boolean>(
        props.allowAdditionalAttendees
    );

    useDidMountEffect(() => {
        setSavingToastKey('additional-attendees');
        onSave({
            allowAdditionalAttendees,
        });
    }, [allowAdditionalAttendees]);

    return (
        <StackLegacy spacing={8}>
            <Checkbox
                label='Allow invitees to invite additional attendees to this meeting'
                // @ts-expect-error
                type='checkbox'
                role='checkbox'
                checked={allowAdditionalAttendees}
                aria-checked={allowAdditionalAttendees}
                onChange={(nowChecked: boolean) => {
                    setAllowAdditionalAttendees(nowChecked);
                }}
            />
        </StackLegacy>
    );
}
